import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap } from 'rxjs/operators'

import { combineEpicsIsolated } from 'utils/epicRegistry'

import { submitEULAError, submitEULASuccess } from './actions'
import { SUBMIT_EULA_ASYNC } from './constants'

const submitEULAEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(SUBMIT_EULA_ASYNC.INITIATE),
    mergeMap((action) =>
      api.login
        .submitEULA({
          eula_type: action.payload.type,
          eulaVersion: action.payload.eulaVersion,
        })
        .pipe(
          map(({ response }) => submitEULASuccess(response)),
          catchError((error) => of(epicsErrorHandler(submitEULAError, error)))
        )
    )
  )

export default combineEpicsIsolated(submitEULAEpic)
